import { AppFooter } from "@osakabe/auth-service-provider/shell";
import {
  PROJECT_REPOSITORY_LINK_LABEL,
  PROJECT_REPOSITORY_LINK_TITLE,
  PROJECT_REPOSITORY_URL,
} from "../../lib/project-links";

// テストから参照するための定数。実在個人名を含むためテスト側へ書き写さない
// （リポジトリ規約: 実在人物を連想させる個人名をテストデータ・サンプルに使わない）。
export const DASHBOARD_FOOTER_COPYRIGHT = "©Takuro Osakabe ©MEIDENSHA";

// po-board 同等のフッター。GitLab リポジトリへのアイコンリンクは画面左下固定とし、
// コピーライトはフッター中央に配置する。構造は共通シェルの AppFooter に委譲し、
// 既存のクラス名 (dashboard-footer 系) を className 注入して見た目を維持する。
// ラベルと title は AppFooter の既定任せにせず共有定数で明示する。既定任せだと、
// 共通シェルが既定文言を変えた時点でキャンバス画面側と文言がずれる。
export function DashboardFooter(): JSX.Element {
  return (
    <AppFooter
      classNames={{
        root: "dashboard-footer",
        link: "dashboard-footer__link",
        gitlabIcon: "dashboard-footer__gitlab-logo",
        srOnly: "visually-hidden",
        copyright: "dashboard-footer__copyright",
      }}
      copyright={DASHBOARD_FOOTER_COPYRIGHT}
      repositoryUrl={PROJECT_REPOSITORY_URL}
      repositoryLinkLabel={PROJECT_REPOSITORY_LINK_LABEL}
      linkTitle={PROJECT_REPOSITORY_LINK_TITLE}
    />
  );
}
